import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = anon, obj = admin
  useEffect(() => {
    if (!getToken()) { setAdmin(false); return; }
    api.get("/auth/me").then(({ data }) => setAdmin(data)).catch(() => { clearToken(); setAdmin(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setAdmin(data.user);
  };
  const logout = () => { clearToken(); setAdmin(false); };

  return <AuthCtx.Provider value={{ admin, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
